import { useTranslation } from "react-i18next";
import React from "react";
import {APP_URLS, STORAGE} from "../../../app/config";
import { NoCompanyLogo } from "../../../assets/images";
import { Button } from "@mui/material";
import axios from "axios";

function CompanyInfoSection({ model, onRefresh }) {
    const { t } = useTranslation('CompanyCreateScreen', { keyPrefix: 'InfoSection' });

    const handleUploadAcceptanceEmail = async (event) => {
        await handleSendLogo({
            id: model.id,
            acceptanceEmail: event.target.files[0],
        });

        onRefresh();
    }

    const handleSendLogo = async (data) => {
        let form = new FormData();

        if (data.logo) {
            form.append('Logo', data.logo);
        }

        if (data.acceptanceEmail) {
            form.append('AcceptanceEmail', data.acceptanceEmail);
        }

        const token = JSON.parse(localStorage.getItem(STORAGE.ACCESS_TOKEN_KEY))?.token;
        const headers = {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token,
        };

        return await axios.post(
            APP_URLS.COMPANY_LOGO_UPLOAD.replace('{id}', data.id),
            form,
            { headers });
    }

    const handleUploadLogo = async (event) => {
        await handleSendLogo({
            id: model.id,
            logo: event.target.files[0],
        });

        onRefresh();
    }
    
    if(!model.id) {
        return null;
    }

    return (
        <div className="fk-form-section">
            <h3 className="title">
                {model?.name ? model.name : t('title')}
            </h3>
            <img
                className="logo"
                src={model?.logo ? `${APP_URLS.UPLOADS}${model.logo}` : NoCompanyLogo}
                alt=""
            />
            <div className="fk-company-logo-uploads">
                <div className="fk-company-logo-acceptance">
                    <Button component="label">
                        {t('uploadAcceptanceEmail')}
                        <input hidden type="file" onChange={handleUploadAcceptanceEmail} />
                    </Button>
                </div>
                <div className="fk-company-logo">
                    <Button component="label">
                        {t('uploadLogo')}
                        <input hidden type="file" onChange={handleUploadLogo} />
                    </Button>
                </div>
                {model?.logoAcceptanceEmail &&
                    <div className="fk-company-acceptance-download">
                        <Button component="a" href={`${APP_URLS.UPLOADS}${model?.logoAcceptanceEmail}`}>
                            {t('downloadAcceptanceEmail')}
                        </Button>
                    </div>
                }
            </div>
        </div>
    );
}



export default CompanyInfoSection;